import { format, parseISO } from "date-fns"
import { FormComponentType } from "@components/FormBuilder/types"
import { GenericForm } from "@custom-types/form"
import { DropdownOptions } from "@custom-types/common"
import { ProductFamily } from "@custom-types/products"
import { GraphDto } from "@custom-types/graphs"
import semver from "semver/preload"
import { MRT_ColumnDef as Column } from "material-react-table"

type getProductFormFieldsProps = {
  organisationOptions: DropdownOptions
  divisionOptions: DropdownOptions
}

export const getGraphsColumns = (): Column<GraphDto>[] => [
  {
    accessorKey: "name",
    header: "Name",
    size: 200,
  },
  {
    accessorKey: "version",
    header: "Version",
    sortingFn: (rowA, rowB) => {
      try {
        return semver.compare(rowA.original.version, rowB.original.version)
      } catch (error) {
        return -1
      }
    },
  },
  {
    accessorKey: "product_key",
    header: "Product",
    size: 150,
  },
  {
    accessorKey: "product_organisation_key",
    header: "Organisation",
    size: 150,
  },
  {
    accessorKey: "product_division_key",
    header: "Division",
    size: 150,
  },
  {
    accessorKey: "published",
    header: "Published",
    accessorFn: (row: GraphDto) => (row.published ? "✅" : "❌"),
    size: 75,
  },
  {
    accessorKey: "creator_email",
    header: "Creator Email",
  },
  {
    accessorKey: "creation_date",
    accessorFn: (row: GraphDto) => format(new Date(row.creation_date), "yyyy-MM-dd [HH:mm]"),
    header: "Created",
    maxSize: 100,
  },
]

export const getProductFamiliesColumns = (): Column<ProductFamily>[] => [
  {
    accessorKey: "name",
    header: "Name",
    size: 300,
  },
  {
    accessorKey: "organisation",
    header: "Organisation",
  },
  {
    accessorKey: "product",
    header: "Product",
    size: 200,
  },
  {
    accessorKey: "is_public",
    header: "Public",
    size: 75,
  },
  {
    accessorKey: "creator_email",
    header: "Creator Email",
  },
  {
    accessorKey: "creation_date",
    accessorFn: (row: ProductFamily) => format(new Date(row.creation_date), "yyyy-MM-dd [HH:mm]"),
    header: "Created",
    maxSize: 100,
  },
]

export const getProductFormFields = ({
  organisationOptions = [],
  divisionOptions = [],
}: getProductFormFieldsProps): GenericForm => ({
  name: {
    title: "Name",
    editable: false,
    type: FormComponentType.NameInput,
  },
  description: {
    title: "Description",
    editable: true,
    type: FormComponentType.Textarea,
  },
  organisation_key: {
    title: "Organisation",
    editable: false,
    type: FormComponentType.Dropdown,
    options: organisationOptions,
  },
  division_key: {
    title: "Division",
    editable: false,
    type: FormComponentType.Dropdown,
    options: divisionOptions,
  },
  creator_email: {
    title: "Creator Email",
    editable: false,
    type: FormComponentType.Input,
  },
  active: {
    title: "Active",
    editable: true,
    type: FormComponentType.Checkbox,
  },
  is_external: {
    title: "Is External",
    editable: true,
    type: FormComponentType.Checkbox,
  },

  creation_date: {
    title: "Creation Date",
    editable: false,
    type: FormComponentType.Date,
    modifier: (value) => format(parseISO(value ? value : new Date().toISOString()), "dd/MM/yyyy"),
  },
  last_updated: {
    title: "Last Updated",
    editable: false,
    type: FormComponentType.Date,
    modifier: (value) => format(parseISO(value ? value : new Date().toISOString()), "dd/MM/yyyy"),
  },
})
